import { baseUrl, spotfireBaseUrl } from "config/settings";

const helvetiaOverview = "/helvetia-data";
const helvetiaDetailsView = helvetiaOverview + "/component";
const amkorLotDataView = "/amkor-lot-data";
const systemEdcParser = "/system-edc-parser";
const parametricAPI = "/parametric-data";
const usersAPI = "/users/";
const externalRoles = "/usermanagement/v1/glasswall/roles";
const getRoleById = "/usermanagement/v1/glasswall/roles?&roleId=:roleId";
const suppliersAPI = "/suppliers/";

export const apis = {
  authCookie: baseUrl + "/api/authcookie",
  helvetiaOverview: baseUrl + helvetiaOverview,
  helvetiaDetailsView: baseUrl + helvetiaDetailsView,
  amkorLotDataView: baseUrl + amkorLotDataView,
  systemEdcParser: baseUrl + systemEdcParser,
  parametricAPI: baseUrl + parametricAPI,
  refreshParametricAPI: baseUrl + parametricAPI + "/refresh",
  usersAPI: baseUrl + usersAPI,
  userManagementAPIGlasswall: baseUrl + "/usermanagement/v1/glasswall",
  externalRolesAPI: baseUrl + externalRoles,
  userManagementAPI: baseUrl + "/usermanagement/v1/external/",
  externalPermissionsAPI: (
    roleName = undefined,
    permissionName = undefined
  ) => {
    if (roleName) {
      return `${baseUrl}/usermanagement/v1/external/rolesPermissions?roleName=${roleName}`;
    }
    if (permissionName) {
      return `${baseUrl}/usermanagement/v1/external/rolesPermissions?permissionName=${permissionName}`;
    }
    return `${baseUrl}/usermanagement/v1/external/permissions`;
  },

  deleteExternalPermissionsAPI: `${baseUrl}/usermanagement/v1/glasswall/permissions`,
  createExternalPermissionsAPI: `${baseUrl}/usermanagement/v1/glasswall/permissions`,
  getExternalPermissionsAPI: `${baseUrl}/usermanagement/v1/glasswall/permissions`,
  updateExternalPermissionsAPI: `${baseUrl}/usermanagement/v1/glasswall/permissions`,

  GWAPI: baseUrl + "/glasswall-api",
  getRoleById: (roleId) => {
    if (roleId) {
      return getRoleById.replace(":roleId", roleId);
    } else {
      throw new Error("Role ID is required");
    }
  },
  suppliersAPI: baseUrl + suppliersAPI,
};

export const views = {
  spotfireAPI: baseUrl + "/spotfire/wp/GetJavaScriptApi.ashx?Version=7.11",
  s3Explorer:
    "https://adv-glasswall-fe-public.s3.eu-central-1.amazonaws.com/filesexplorer.html",
  wpTmplUrl: spotfireBaseUrl + "/render/2_Op3RslUC3w4gEc06/analysis?file=",
  reporting:
    "https://app.powerbi.com/reportEmbed?reportId=3f46008d-adf4-4cf4-aa63-a137199b4bc9&autoAuth=true&ctid=b0de9dff-4833-4d4f-b442-1e0dbfae2ec8&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXdlc3QtdXMtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D",
};
